import { Card, Typography } from "antd";
import React from "react";
import "../Pages/CSS/DonnesBases.css";
import InfosGen from "./InfosGen";

const { Title } = Typography;

const Informations = () => {
  return (
    <div>
      <Card
        // title={<Title level={3}><strong>Informations Générales</strong></Title>}
        style={{
          width: "100%",
        }}
      >
        <InfosGen />
      </Card>
    </div>
  );
};

export default Informations;
